import { useParams } from "react-router-dom";
import { atom, useAtom } from "jotai";

import { T } from "@repo/transifex";
import { getErrorMessage } from "@repo/system";
import { useTill } from "~/api/tills/hooks/use-till";
import { useOpenTillSession } from "~/hooks/queries/sessions";
import { useAppContext, useBasketProducts } from "~/providers/app";
import { Button, DialogError, DialogLoading } from "~/components";

export const startedCashBalanceAtom = atom(0);

export const HeaderButtonOpenSession = () => {
  const { tillId } = useParams();

  const {
    hardware: { printer }
  } = useAppContext();

  const {
    meta: { currency }
  } = useBasketProducts();

  const { mutate: createTillSession, status, error } = useOpenTillSession();
  const { data: till, status: tillStatus } = useTill(tillId);

  const [startedCashBalance, setStartedCashBalance] = useAtom(
    startedCashBalanceAtom
  );

  if (tillStatus !== "success") return null;

  const handleConfirm = () => {
    createTillSession({
      deviceId: till.deviceId ?? "",
      printerId: printer?.identifier ?? "",
      tillId: till.id,
      startedCashBalance,
      currency
    });

    setStartedCashBalance(0);
  };

  return (
    <>
      <Button className="ml-auto" onClick={handleConfirm} variant="primary">
        <T _str="Open register" />
      </Button>

      {status === "pending" && <DialogLoading />}
      {status === "error" && (
        <DialogError
          backUrl={tillId ? `settings/tills/${tillId}` : "settings/tills"}
          error={getErrorMessage(error)}
        />
      )}
    </>
  );
};
